import { Card } from '@/components/Card';

export function SourceCardSkeleton() {
    return <Card loading />;
}
